import styled from 'styled-components';

export const DashboardWrapper = styled('div')``;

export const RouterWrapper = styled('div')`
  ${({ theme: { spacing } }) => `
    width: ${spacing.full};
  `}
`;

export const ContentWrapper = styled('div')`
  ${({ theme: { breakpoint } }) => `
    display: flex;
    @media screen and (max-width: ${breakpoint.md}) {
      flex-direction: column;
    }
  `}
`;

export const MainWrapper = styled('div')`
  ${({ theme: { spacing }, shouldNotAddMargin }) => `
    width: ${spacing.full};
    padding-bottom: ${shouldNotAddMargin ? spacing.px0 : spacing.px40};
    margin-top: ${shouldNotAddMargin ? spacing.px0 : spacing.px40};
  `}
`;
